module.exports = __webpack_public_path__ + "static/ruchi-3838e29afbf5ebe96e532ded98b95e31.png";